<section class="w-[420px] max-w-full">
  <h3 class="text-lg font-semibold text-gray-900">Supprimer {{ companyName() }} ?</h3>
  <p class="text-sm text-gray-600 mt-2">
    Cette action retire l'entreprise de votre espace utilisateur.
  </p>

  @if (eligibility()?.cooldownApplies) {
    <p class="text-sm text-amber-800 mt-3 rounded-lg border border-amber-200 bg-amber-50 px-3 py-2">
      {{ eligibility()?.message }}
    </p>
    @if (!canRemove() && eligibility()?.nextRemovalAvailableAt) {
      <p class="text-sm text-amber-900 mt-2 font-medium">
        Prochaine suppression possible le {{ eligibility()?.nextRemovalAvailableAt }}.
      </p>
    }
  }

  <div class="flex justify-end gap-2 mt-6">
    <button
      type="button"
      (click)="cancel()"
      class="px-4 py-2 rounded-md border border-gray-300 text-gray-700 hover:bg-gray-50 cursor-pointer"
    >
      Annuler
    </button>
    <button
      type="button"
      (click)="confirm()"
      [disabled]="!canRemove()"
      class="px-4 py-2 rounded-md bg-red-600 text-white hover:bg-red-700 cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
    >
      Supprimer
    </button>
  </div>
</section>
